
import { Component, Mixins, Vue } from "vue-property-decorator";
import VueRecaptcha from "vue-recaptcha";
import FormValidator from "@/mixins/FormValidator";
import vueFilePond, { setOptions } from "vue-filepond";
import "filepond/dist/filepond.min.css";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import FilePondPluginFileValidateSize from "filepond-plugin-file-validate-size";
import { debounce } from "quasar";
import DateHelpers from "@/mixins/DateHelpers";
import DeclaracionInicioInves from "../dialogs/DeclaracionInicioInves.vue";
// import PreguntasDinamicas from "@/components/forms/PreguntasDinamicas.vue";
const FilePond = vueFilePond(
  FilePondPluginFileValidateType,
  FilePondPluginImagePreview,
  FilePondPluginFileValidateSize
);

interface ticketData {
  district: any;
  street: string;
  street_number: string;
  hint: string;
  message: string;
}

interface respuesta {
  id_pregunta: number | null;
  id_formulario: number | null;
  pregunta: string | null;
  respuesta: string | null;
  tipo: number | null;
  obligatorio: number | null;
}

interface dataRespuesta {
  id_formulario: number | null;
  preguntas: Array<respuesta>;
}

@Component({
  components: {
    FilePond,
    VueRecaptcha,
    DeclaracionInicioInves
  }
})
export default class SendTicketForm extends Mixins(FormValidator, DateHelpers) {
  // razonSocial: any = null;
  // tipo_usuario: number | null = null;

  rut_empresa = null;

  // personaJuridicaValue = false;

  protected formDataEmpresa = {
    document_id: ""
  };

  private base_bucket = process.env.VUE_APP_AWS_ASSETS;
  protected formData: ticketData = {
    district: "",
    street: "",
    street_number: "",
    hint: "",
    message: ""
  };

  comunas: Array<any> = [];
  options_district: any = [];
  options_street: any = [];
  street_loading = false;
  check_loading = false;
  street_search_empty = false;
  disable_button = false;
  streets: any[] = [];
  uploadProgressBar = false;
  uploadProgressPercent = 0;
  private requiereDocumento: boolean = false;
  private mensajeDocumento: string = "";
  private mostrarMensajeDocumento: boolean = false;
  private data_preguntas: any = [];

  private company_rut = "";
  private business_name = "";
  private worker_rut = "";
  private worker_name = "";

  private question_one: any = null;
  private question_two: any = null;
  private question_three: any = null;

  private requiredCheckboxJuridica = false;

  private declaracionCheckbox: string = "no";
  private declaracion: boolean = false;
  private declaracionFooter: boolean = false;

  private info_dialog: boolean = false;

  private preguntas: Array<any> = [
    {
      id: 1,
      id_formulario: 2,
      pregunta: "Ingrese el rol de la propiedad (opcional)",
      tipo: 0,
      obligatorio: 0,
      icon: "place",
      label: "Rol de la propiedad"
    },
    {
      id: 2,
      id_formulario: 2,
      pregunta: "Ingrese dirección de la propiedad (opcional)",
      tipo: 0,
      obligatorio: 0,
      icon: "place",
      label: "Dirección de la propiedad"
    },
    {
      id: 3,
      id_formulario: 2,
      pregunta:
        "Si cuenta con n° de expediente anterior, ingresar aquí (opcional)",
      tipo: 0,
      obligatorio: 0,
      icon: "place",
      label: "Dirección de la propiedad"
    }
  ];

  options_tipo_usuario: Array<any> = [
    { value: 1, label: "Persona Trabajadora" },
    { value: 2, label: "Entidad Empleadora" },
    { value: 3, label: "Estudiante" },
    { value: 4, label: "Dirigente Sindical" },
    // { value: 5, label: "Responsable del Hogar" },
    { value: 6, label: "Persona Jubilada" },
    { value: 7, label: "Sector Público" },
    { value: 8, label: "Otro Perfil" }
  ];

  id_formulario = 0;
  mensaje = "";

  private mensajeEntidadJuridica =
    "Si esta solicitud tiene relación con una empresa señale datos como el RUT empresa/Razón social, domicilio, etc";

  private mensajeAdjunto = this.$store.state.ticket.motive != 9 ?
    "Si desea complementar información puede adjuntar documentos (PDF, JPG, DOC o similares)" :
    "Estimado Empleador/a: Adjunte en su solicitud de “Depósito de Investigación” todos los documentos pertinentes al desarrollo de su investigación. \
    Encontrará orientaciones en el <a href='" + this.base_bucket + "/static/pdf_tramite_deposito.pdf' target='_blank'><b>DOCUMENTO EXPLICATIVO</b></a>. \
    En caso de omitirse alguno de los documentos requeridos no se podrá dar curso al trámite solicitado.";

  private mensajeMessage =
    "Le solicitamos que nos entregue la mayor cantidad de información que nos ayude a dar una mejor respuesta a su requerimiento, como por ejemplo fechas, folios, nombre de oficina, RUT empresa, etc";

  private default_address: number = 0;
  private loading: boolean = false;

  private mensaje_9: string =
      "Indicar la dirección (comuna, calle y número) <b>donde ocurrieron los hechos denunciados.</b> <br/><br/>\
      Detalle la Fecha de Recepción de la Denuncia, Fechas de Inicio y Término de la Investigación, junto con los datos del trabajador denunciante (Nombre/Rut). <br/><br/>\
      <b>IMPORTANTE:</b> En caso de omitirse alguno de los datos requeridos no se podrá dar curso al trámite solicitado.";
  private mensaje_10: string =
      "Indicar la dirección (comuna, calle y número) <b>donde ocurrieron los hechos denunciados.</b> <br/><br/>\
      Detalle la Fecha de Recepción de la Denuncia, Fecha de Inicio de la Investigación y Medidas de Resguardo adoptadas, junto con los datos del trabajador denunciante (Nombre/Rut). <br/><br/>\
      <b>IMPORTANTE:</b> En caso de omitirse alguno de los datos requeridos no se podrá dar curso al trámite solicitado.";
  private mensaje_11: string =
      "Indicar la dirección (comuna, calle y número) <b>donde ocurrieron los hechos denunciados.</b> <br/><br/>\
      Detalle la Fecha de Recepción de la Denuncia y Medidas de Resguardo adoptadas, junto con los datos del trabajador denunciante (Nombre/Rut). <br/><br/>\
      <b>IMPORTANTE:</b> En caso de omitirse alguno de los datos requeridos no se podrá dar curso al trámite solicitado.";

  private my_locale = {
    days: "Domingo_Lunes_Martes_Miércoles_Jueves_Viernes_Sábado".split("_"),
    daysShort: "Dom_Lun_Mar_Mié_Jue_Vie_Sáb".split("_"),
    months: "Enero_Febrero_Marzo_Abril_Mayo_Junio_Julio_Agosto_Septiembre_Octubre_Noviembre_Diciembre".split(
      "_"
    ),
    monthsShort: "Ene_Feb_Mar_Abr_May_Jun_Jul_Ago_Sep_Oct_Nov_Dic".split("_"),
    firstDayOfWeek: 1
  };

  private notify(message: string) {
    this.$q.notify({
      message: message,
      color: "principal",
      position: "top",
      timeout: 5000
    });
  }

  protected captcha_key = "";
  private beforeMount() {
    this.captcha_key = process.env.VUE_APP_KEY_CAPTCHA as string;
  }

  protected formatRutWorker(rut: string) {
    this.worker_rut = this.formatRutEmpresa(rut)
  }

  private mostrarDeclaracion() {
    this.declaracion = true;
    this.declaracionFooter = true;
  }

  private onCloseDeclaracion(info: any) {
    if (info == true) {
      this.declaracionCheckbox = "si";
      this.declaracion = false;
    } else if (info == false) {
      this.declaracionCheckbox = "no";
      this.declaracion = false;
    } else {
      this.declaracion = false;
    }
  }

  protected formatRutEmpresa(rut: string) {
    if (rut.replace("-", "").replace(/[.-]/g, "").replace(/\s/g, "").length <= 7) {
      rut = rut
        .replace("-", "")
        .replace(/[.-]/g, "")
        .replace(/\s/g, "")
        .replace(/^(\d{3})(\d{3})(\w{1})$/, "$1.$2-$3");
    } else {
      rut = rut
        .replace("-", "")
        .replace(/[.-]/g, "")
        .replace(/\s/g, "")
        .replace(/^(\d{0,2})(\d{3})(\d{3})(\w{1})$/, "$1.$2.$3-$4");
    }
    return rut;
  }

  private limitQuestionOne(date: any) {
    var limiter = Date.parse(date as any) <= Date.now();

    if (this.question_two) {
      let dateEnd = this.question_two.split("-");
      let endObject = new Date(
        +dateEnd[2],
        (dateEnd[1] as any) - 1,
        +dateEnd[0]
      );
      limiter =
        limiter && Date.parse(date as any) <= Date.parse(endObject as any);
    }

    if (this.question_three) {
      let dateEnd = this.question_three.split("-");
      let endObject = new Date(
        +dateEnd[2],
        (dateEnd[1] as any) - 1,
        +dateEnd[0]
      );
      limiter =
        limiter && Date.parse(date as any) <= Date.parse(endObject as any);
    }
    return limiter;
  }

  private limitQuestionTwo(date: any) {
    var limiter = Date.parse(date as any) <= Date.now();

    if (this.question_one) {
      let dateStart = this.question_one.split("-");
      let startObject = new Date(
        +dateStart[2],
        (dateStart[1] as any) - 1,
        +dateStart[0]
      );
      limiter =
        limiter && Date.parse(date as any) >= Date.parse(startObject as any);
    }

    if (this.question_three) {
      let dateEnd = this.question_three.split("-");
      let endObject = new Date(
        +dateEnd[2],
        (dateEnd[1] as any) - 1,
        +dateEnd[0]
      );
      limiter =
        limiter && Date.parse(date as any) <= Date.parse(endObject as any);
    }
    return limiter;
  }

  private limitQuestionThree(date: any) {
    var limiter = Date.parse(date as any) <= Date.now();
    if (this.question_one) {
      let dateStart = this.question_one.split("-");
      let startObject = new Date(
        +dateStart[2],
        (dateStart[1] as any) - 1,
        +dateStart[0]
      );
      limiter =
        limiter && Date.parse(date as any) >= Date.parse(startObject as any);
    }

    if (this.question_two) {
      let dateEnd = this.question_two.split("-");
      let endObject = new Date(
        +dateEnd[2],
        (dateEnd[1] as any) - 1,
        +dateEnd[0]
      );
      limiter =
        limiter && Date.parse(date as any) >= Date.parse(endObject as any);
    }
    return limiter;
  }

  private dateQuestionOne() {
    (this.$refs as any).qDateProxyOne.hide();
  }

  private dateQuestionTwo() {
    (this.$refs as any).qDateProxyTwo.hide();
  }

  private dateQuestionThree() {
    (this.$refs as any).qDateProxyThree.hide();
  }

  private areAllFilesOK(): boolean {
    let files = (this.$refs.pond as any).getFiles();
    for (let i = 0; i < files.length; i++) {
      if (files[i].status != 5) {
        return false;
      }
    }
    return true;
  }

  private getServicioMeta() {
    this.$axios
      .get("servicio-metas", {
        params: {
          filter: {
            where: {
              and: [
                { id_servicio: Number(this.$store.state.ticket.service.id) },
                { meta_key: "reservation_message" }
              ]
            }
          }
        }
      })
      .then(response => {
        if (response.data.length == 0) this.mensaje = "";
        else this.mensaje = response.data[0].meta_value;
      })
      .catch(error => {
        this.notify("Ha ocurrido un error");
      });
  }

  private triggerFilepond() {
    (document.getElementsByClassName(
      "filepond--browser"
    )[0] as HTMLInputElement).click();
  }

  private typeDetection(file: any, type: any) {
    let checkExtensions = ["doc", "docx", "xls", "xlsx", "ppt", "pptx"];
    let isAllowed = new Promise((resolve, reject) => {
      let extension = file.name
        .split(".")
        .pop()
        .toLowerCase();
      if (checkExtensions.indexOf(extension) > -1) {
        let officeType = "";
        switch (extension) {
          case "doc":
          case "docx":
            officeType = "application/doc";
            break;
          case "xls":
          case "xlsx":
            officeType = "application/xls";
            break;
          case "ppt":
          case "pptx":
            officeType = "application/ppt";
            break;
          case "msg":
            officeType = "application/vnd.ms-outlook";
            break;
          default:
            officeType = "";
            break;
        }
        if (officeType === "") {
          reject();
        } else {
          resolve(officeType);
        }
      } else {
        resolve(type);
      }
    });
    return isAllowed;
  }

  onVerify(response: any) {
    this.validateForm();
  }

  onExpired() {
    this.$q.notify({
      color: "negative",
      message: "Por favor, recargue la página.",
      icon: "report_problem",
      position: "top",
      timeout: 2500
    });
  }

  onError() {
    this.$q.notify({
      color: "negative",
      message: "Ha ocurrido un error, intente más tarde.",
      icon: "report_problem",
      position: "top",
      timeout: 2500
    });
  }

  private validateForm() {
    (this.$refs.registerForm as any).validate().then((response: Boolean) => {
      if (response) this.sendTicketAttemp();
    });
  }

  private sendTicketAttemp() {
    //ordenar input de archivos filepond)
    let adjuntos_input = document.getElementsByName("Files");
    //backend no soporta vacio, debe ser null
    let adjuntos_empty = true;
    let adjuntos: any = [];
    for (let i = 0; i < adjuntos_input.length; i++) {
      adjuntos[i] = (adjuntos_input[i] as HTMLInputElement).value;
    }
    for (let j = 0; j < adjuntos.length; j++) {
      if (adjuntos[j] !== "") {
        adjuntos_empty = false;
      }
    }
    if (adjuntos_empty) {
      adjuntos = null;
    }

    this.disable_button = true;
    let error_flag = false;
    let mensaje = "";
    const files = this.$refs.pond ? (this.$refs.pond as any).getFiles() : [];

    if (files.length == 0) this.$q.loading.show();

    let captcha = (window as any).grecaptcha.getResponse();

    if (captcha == "") {
      mensaje = this.$t("notification.check_captcha") as string;
      error_flag = true;
    } else if (this.formData.street.length == 0) {
      mensaje = "Debe ingresar la calle de la dirección";
      error_flag = true;
    } else if (this.formData.street_number.length == 0) {
      mensaje = "Debe ingresar el número de la dirección";
      error_flag = true;
    } else if (this.formData.message.length == 0) {
      mensaje = "Debe ingresar un mensaje";
      error_flag = true;
    } else if (
      this.requiereDocumento &&
      files.length === 0 &&
      this.$store.state.ticket.motive == 9
    ) {
      mensaje = "Se debe adjuntar el documento solicitado";
      error_flag = true;
    } else if(
      this.$store.state.ticket.motive == 10 && this.declaracionCheckbox == "no"
    ) {
      mensaje = "Debe aceptar la declaración";
      error_flag = true;
    }

    if (
      typeof this.checkQuestionOne() === "string" &&
      this.checkQuestionOne().length != 0
    ) {
      mensaje = this.checkQuestionOne();
      error_flag = true;
    }

    if (
      typeof this.checkQuestionTwo() === "string" &&
      this.checkQuestionTwo().length != 0 &&
      [9, 10].includes(Number(this.$store.state.ticket.motive))
    ) {
      mensaje = this.checkQuestionTwo();
      error_flag = true;
    }

    if (
      typeof this.checkQuestionThree() === "string" &&
      this.checkQuestionThree().length != 0 &&
      [9].includes(Number(this.$store.state.ticket.motive))
    ) {
      mensaje = this.checkQuestionThree();
      error_flag = true;
    }

    if (error_flag) {
      this.notify(mensaje);
      this.$q.loading.hide();
      return (this.disable_button = false);
    }

    const formData = new FormData();
    let validFiles = true;
    for (let index = 0; index < files.length; index++) {
      if (files[index].fileSize < 1024 * 1024 * 51) {
        formData.append("my-file-" + index, files[index].file);
      } else {
        validFiles = false;
      }
    }
    if (!validFiles) {
      this.$q.loading.hide();
      return this.notify(
        "Los archivos adjuntos no deben exceder el máximo permitido (50mb)"
      );
    }
    let flag = true;
    if (
      this.data_preguntas &&
      this.data_preguntas.length > 0 &&
      this.$store.state.ticket.motive == 1
    ) {
      for (let i = 0; i < this.data_preguntas.length; i++) {
        if (
          this.data_preguntas[i].obligatorio == 1 &&
          this.data_preguntas[i].respuesta === ""
        ) {
          flag = false;
        }
      }
    }

    if (files.length > 0) this.uploadProgressBar = true;
    formData.append('ticket', JSON.stringify({
      tipo_usuario: null,
      rut_empresa: this.$store.state.ticket.company_rut,
      razon_social: this.$store.state.ticket.company_name,
      rut_trabajador: this.worker_rut,
      nombre_trabajador: this.worker_name,
      correo_ncc: this.$store.state.ticket.ncc,
      fecha_recepcion: this.question_one
        ? this.birthDate(this.question_one)
        : null,
      fecha_inicio: this.question_two
        ? this.birthDate(this.question_two)
        : null,
      fecha_termino: this.question_three
        ? this.birthDate(this.question_three)
        : null,
      id_servicio: this.$store.state.ticket.service.id,
      tipo: Number(this.$store.state.ticket.motive), //motivo de solicitud
      rut: this.$store.state.logged
        ? this.$store.state.user.rut
        : this.$store.state.ticket.guest_id,
      tipo_documento: this.$store.state.logged
        ? Number(this.$store.state.user.document_type)
        : Number(this.$store.state.ticket.guest_document_type),
      adjunto: adjuntos,
      mensaje: this.formData.message,
      direccion: {
        id_comuna: this.formData.district.value,
        calle: this.formData.street,
        numero: this.formData.street_number,
        aclaratoria: this.formData.hint
      },
      dispositivo: navigator.userAgent
    }))
    if (flag) {
      this.$axios
        .post("tickets/solicitud/v2", formData, {
          headers: {
            ...(this.$store.state.user.auth_token && {
              Authorization: "Bearer " + this.$store.state.user.auth_token
            }),
            Captcha: captcha ? captcha : null
          },
          onUploadProgress: progressEvent => {
            this.uploadProgressPercent =
              progressEvent.loaded / progressEvent.total;
          }
        })
        .then(response => {
          this.enviarPreguntas(response.data.id_ticket);

          let ticket = {
            id: response.data.id_ticket,
            message: response.data.mensaje,
            date: response.data.fecha,
            step: 4,
            adjuntos: response.data.adjunto ? response.data.adjunto : null,
            calle: this.formData.street,
            numero: this.formData.street_number,
            aclaratoria: this.formData.hint,
            estado_ticket: response.data.estado_ticket,
            nombre_estado: response.data.nombre_estado,
            correlativo: response.data.correlativo,
            direccion_default: response.data.direccion_default
          };

          this.$store.dispatch("submitRequestFinished", ticket);
        })
        .catch(error => {
          let message = "Ha ocurrido un problema";
          switch (error.response.data.error.message) {
            case "upload_adjunto_error":
              message =
                "Ha ocurrido un problema con los archivos adjuntos. Intente nuevamente";
              break;
            case "empty_captcha":
            case "invalid_captcha":
              message = "Ha ocurrido un error validando su captcha";
              break;
            case "empty_rut_empresa":
              message =
                "El campo RUT de la empresa no fue seleccionado correctamente";
              break;
            case "empty_razon_social":
              message =
                "El campo razón social de la empresa no fue seleccionado correctamente";
              break;
            case "empty_correo_ncc":
              message =
                "El campo correo NCC de la empresa no fue seleccionado correctamente";
              break;
            case "empty_date":
              message = "Debe completar los campos de fecha requeridos";
              break;
          }
          this.notify(message);
        })
        .finally(() => {
          this.$q.loading.hide();
          this.disable_button = false;
          this.uploadProgressBar = false;
          this.uploadProgressPercent = 0;
        });
    } else {
      this.$q.loading.hide();
      this.disable_button = false;
      this.notify("Rellene los campos obligatorios (*)");
    }
  }

  /*private get canAutoFillAdress() {
    if (this.$store.state.logged) {
      if (this.$store.state.user.adress.district == this.comuna_cliente) {
        return true;
      }
    } else {
      if (
        this.$store.state.ticket.guest_adress_district == this.comuna_cliente
      ) {
        return true;
      }
    }
    return false;
  }

  private autoFillAdress() {
    if (this.$store.state.logged) {
      this.formData.street = this.$store.state.user.adress.street;
      this.formData.street_number = this.$store.state.user.adress.number;
      this.formData.hint = this.$store.state.user.adress.hint;
    } else {
      this.formData.street = this.$store.state.ticket.guest_adress_street;
      this.formData.street_number = this.$store.state.ticket.guest_adress_number;
      this.formData.hint = this.$store.state.ticket.guest_adress_hint;
    }
    return false;
  }*/

  private filterDistrict(val: string, update: any) {
    if (val === "") {
      update(() => {
        this.options_district = this.comunas;
      });
      return;
    }

    update(() => {
      const value = val.toLowerCase();
      this.options_district = (this.comunas as any).filter((comuna: any) => {
        return comuna.label.toLowerCase().indexOf(value) > -1;
      });
      if (this.formData.district) {
        this.options_district.unshift(this.formData.district);
      }
    });
  }

  private abortFilterFn() {}

  private filepondServer = {
    url: process.env.VUE_APP_API_PATH + "/temporal_archivos/",
    process: {
      url: "upload",
      method: "POST",
      withCredentials: false,
      onload: (response: string) => {
        let json_response = JSON.parse(response);
        return json_response.response.nombre;
      },
      onerror: (response: any) => response.data,
      ondata: (formData: any) => {
        return formData;
      }
    },
    revert: "delete",
    restore: null,
    load: null,
    fetch: null
  };

  private checkVerify() {
    this.check_loading = true;
    this.$q.loading.show();
    this.$axios
      .get("personas/checkVerified", {
        headers: {
          Authorization: "Bearer " + this.$store.state.user.auth_token
        }
      })
      .then(response => {
        this.$store.dispatch("setEmailVerified", response.data);
      })
      .catch(error => {
        switch (error.response.data.error.message) {
          case "auth/internal-error":
            this.notify("Ha ocurrido un error interno");
            break;
          case "auth/invalid-uid":
            this.notify("Id inválida");
            break;
          case "auth/missing-uid":
            this.notify("La operación no");
            break;
          case "auth/operation-not-allowed":
            this.notify("Operación no permitida");
            break;
          default:
            this.notify("Error desconocido");
            break;
        }
      })
      .finally(() => {
        this.check_loading = false;
        this.$q.loading.hide();
      });
  }

  private getDefaultAddress() {
    this.$axios.get("direccions/default").then(response => {
      this.formData.street = response.data.calle;
      this.formData.street_number = response.data.numero;
      this.formData.hint = response.data.aclaratoria;
    });
  }

  private getFormulario() {
    this.$q.loading.show();
    this.$axios
      .get("servicios/" + Number(this.$store.state.ticket.service.id), {
        params: {
          filter: {
            fields: [
              "id",
              "direccion_default",
              "requiere_documento",
              "mensaje_documento"
            ],
            include: [
              {
                relation: "formulario",
                scope: {
                  fields: ["id", "id_servicio"],
                  include: [
                    {
                      relation: "formulario_pregunta",
                      scope: {
                        where: { estado: 1 },
                        order: ["prioridad ASC"],
                        fields: [
                          "id",
                          "id_formulario",
                          "pregunta",
                          "tipo",
                          "obligatorio",
                          "icon",
                          "label",
                          "prioridad",
                          "estado"
                        ],
                        include: [
                          {
                            relation: "formulario_pregunta_opcions",
                            scope: {
                              fields: ["id", "id_formulario_pregunta", "label"]
                            }
                          }
                        ]
                      }
                    }
                  ]
                }
              }
            ]
          }
        }
      })
      .then(response => {
        if (response.data.direccion_default == 1) {
          this.default_address = response.data.direccion_default;
          // this.getDefaultAddress();
        }
        this.requiereDocumento =
          response.data.requiere_documento &&
          response.data.requiere_documento == 1
            ? true
            : false;
        this.mensajeDocumento =
          response.data.mensaje_documento &&
          response.data.mensaje_documento != ""
            ? response.data.mensaje_documento
            : "";
        if (response.data.formulario && response.data.formulario.length > 0) {
          for (let i = 0; i < response.data.formulario.length; i++) {
            const pregunta = response.data.formulario[i];
            if (pregunta.formulario_pregunta) {
              for (let j = 0; j < pregunta.formulario_pregunta.length; j++) {
                var tempRespuesta = "";
                if (pregunta.formulario_pregunta[j].tipo == 1) {
                  tempRespuesta = "No";
                } else {
                  tempRespuesta = "";
                }
                var opciones = [];
                if (
                  pregunta.formulario_pregunta[j].formulario_pregunta_opcions
                ) {
                  for (
                    let l = 0;
                    l <
                    pregunta.formulario_pregunta[j].formulario_pregunta_opcions
                      .length;
                    l++
                  ) {
                    opciones.push({
                      value:
                        pregunta.formulario_pregunta[j]
                          .formulario_pregunta_opcions[l].id,
                      label:
                        pregunta.formulario_pregunta[j]
                          .formulario_pregunta_opcions[l].label
                    });
                  }
                }
                this.data_preguntas.push({
                  id_pregunta: pregunta.formulario_pregunta[j].id,
                  id_formulario: pregunta.formulario_pregunta[j].id_formulario,
                  pregunta: pregunta.formulario_pregunta[j].pregunta,
                  respuesta: tempRespuesta,
                  opciones: opciones,
                  tipo: pregunta.formulario_pregunta[j].tipo,
                  obligatorio: pregunta.formulario_pregunta[j].obligatorio,
                  icon: pregunta.formulario_pregunta[j].icon,
                  label: pregunta.formulario_pregunta[j].label
                });
              }
            }
          }
        }
      })
      .catch(error => {
        this.notify("Ha ocurrido un error");
      })
      .finally(() => {
        this.$q.loading.hide();
      });
  }

  private enviarPreguntas(idTicket: any) {
    let respuestas_formulario = this.data_preguntas.filter((item: any) => {
      return item.tipo != 5;
    });
    this.$axios
      .post("formularioRespuesta/createAll", {
        id_ticket: Number(idTicket),
        respuestas: respuestas_formulario
      })
      .then(response => {})
      .catch(error => {
        this.notify("Ha ocurrido un problema");
        this.$q.loading.hide();
        this.disable_button = false;
      });
  }

  private getComunas() {
    this.$axios
      .get("comunas/listar")
      .then(response => {
        this.comunas = response.data;
      })
      .catch(error => {})
      .finally(() => {});
  }

  public isRutForm(value: string) {
    this.disable_button = false;
    let error_flag = false;
    let mensaje = "";

    var texto = value;
    if (texto.length > 12 || texto.length < 8) {
      error_flag = true;

      if (error_flag) {
        this.disable_button = true;
      } else {
        this.disable_button = false;
      }

      return "Ingrese un rut válido";
    }
    var check_letters = texto.match(/([A-Za-z])/g);
    if (check_letters && check_letters.length >= 2) {
      return "El rut no puede tener 2 letras";
    }
    var tmpstr = "";
    for (let i = 0; i < texto.length; i++)
      if (
        texto.charAt(i) != " " &&
        texto.charAt(i) != "." &&
        texto.charAt(i) != "-"
      )
        tmpstr = tmpstr + texto.charAt(i);
    texto = tmpstr;
    var largo = texto.length;
    if (largo < 2) {
      return false;
    }
    for (let i = 0; i < largo; i++) {
      if (
        texto.charAt(i) != "0" &&
        texto.charAt(i) != "1" &&
        texto.charAt(i) != "2" &&
        texto.charAt(i) != "3" &&
        texto.charAt(i) != "4" &&
        texto.charAt(i) != "5" &&
        texto.charAt(i) != "6" &&
        texto.charAt(i) != "7" &&
        texto.charAt(i) != "8" &&
        texto.charAt(i) != "9" &&
        texto.charAt(i) != "k" &&
        texto.charAt(i) != "K"
      ) {
        return false;
      }
    }
    var invertido = "";
    for (let i = largo - 1, j = 0; i >= 0; i--, j++)
      invertido = invertido + texto.charAt(i);
    var dtexto = "";
    dtexto = dtexto + invertido.charAt(0);
    dtexto = dtexto + "-";
    var cnt = 0;
    for (let i = 1, j = 2; i < largo; i++, j++) {
      if (cnt == 3) {
        dtexto = dtexto + ".";
        j++;
        dtexto = dtexto + invertido.charAt(i);
        cnt = 1;
      } else {
        dtexto = dtexto + invertido.charAt(i);
        cnt++;
      }
    }
    invertido = "";
    for (let i = dtexto.length - 1, j = 0; i >= 0; i--, j++)
      invertido = invertido + dtexto.charAt(i);

    if (this.revisarDigito2(texto)) {
      return true;
    }

    this.disable_button = true;

    return this.$t("validation.invalid_rut");
  }

  protected checkQuestionOne(): any {
    //
    if (
      !this.question_one ||
      this.question_one == null ||
      this.question_one == ""
    )
      return "Es obligatorio rellenar el campo fecha de recepción";

    //
    const { question_one } = this;
    //
    if (!/^\d{2}-\d{2}-\d{4}$/.test(question_one))
      return "Formato de fecha de recepción incorrecto";

    //
    if (!this.checkDate(question_one)) return "Fecha de recepción inválida";
    //
    return null;
  }

  protected checkQuestionTwo(): any {
    //
    if (
      !this.question_two ||
      this.question_two == null ||
      this.question_two == ""
    )
      return "Es obligatorio rellenar el campo fecha de inicio investigación";

    //
    const { question_two } = this;
    //
    if (!/^\d{2}-\d{2}-\d{4}$/.test(question_two))
      return "Formato de fecha de inicio investigaciónn incorrecto";

    //
    if (!this.checkDate(question_two))
      return "Fecha de inicio investigación inválida";

    //
    return null;
  }

  protected checkQuestionThree(): any {
    //
    if (
      !this.question_three ||
      this.question_three == null ||
      this.question_three == ""
    )
      return "Es obligatorio rellenar el campo fecha de término investigación";
    //
    const { question_three } = this;
    //
    if (!/^\d{2}-\d{2}-\d{4}$/.test(question_three))
      return "Formato de fecha de término investigación es incorrecta";
    //
    if (!this.checkDate(question_three))
      return "Fecha de término investigación inválida";
    //
    return null;
  }

  private mounted() {
    this.getComunas();
    this.getFormulario();
    this.getServicioMeta();
    if (this.$store.state.logged) {
      this.checkVerify();
    }
    //
    if (this.$store.state.ticket.company_rut) {
      this.company_rut = this.formatRutEmpresa(
        this.$store.state.ticket.company_rut
      );
    }
    if (this.$store.state.ticket.company_name) {
      this.business_name = this.$store.state.ticket.company_name;
    }
  }
}
